import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrapper = css`
  display: flex;
  align-items: center;
  gap: ${size[60]};
  justify-content: center;
  position: relative;
  max-width: 100%;
  margin: ${size[80]} auto;
  padding: ${size[24]};
  ${breakpoint.up('lg')} {
    padding: ${size[128]} ${size[96]};
  }

  overflow: hidden;
`

export const text = css`
  max-width: 100%;
  ${breakpoint.up('lg')} {
    max-width: ${width.container.compact};
  }
`

export const title = (theme: Theme) => css`
  margin-top: 0;
  max-width: ${pxToRem(720)};
  color: ${theme.palette.text.title};
  font-weight: 700;
  margin-bottom: ${size[32]};

  font-size: ${pxToRem(28)};
  ${breakpoint.up('lg')} {
    margin-bottom: ${size[40]};
    font-size: ${pxToRem(48)};
  }

  span {
    color: ${theme.palette.primary.mainContrast};
  }
`

export const description = css`
  max-width: ${width.container.compact};
  margin-bottom: ${size[24]};
  ${breakpoint.up('lg')} {
    margin-bottom: ${size[48]};
  }

  font-size: ${pxToRem(18)};
  ${breakpoint.up('lg')} {
    font-size: ${pxToRem(24)};
  }

  span {
    font-weight: 500;
  }
`

export const buttons = css`
  display: flex;
  gap: ${size[16]};
  flex-direction: column;
  align-items: stretch;

  a {
    width: 100%;
  }

  ${breakpoint.up('lg')} {
    gap: ${size[24]};
    flex-direction: row;
    a {
      width: initial;
    }
  }
`

export const blocksDesktop = css`
  flex-wrap: wrap;
  gap: ${size[24]};
  max-width: 720px;

  display: none;
  ${breakpoint.up('lg')} {
    display: flex;
  }
`

export const blocksMobile = css`
  gap: ${size[24]};
  margin-bottom: ${size[24]};
  overflow-x: auto;
  scroll-snap-type: x proximity;

  display: flex;
  ${breakpoint.up('lg')} {
    display: none;
  }
`

export const card = (theme: Theme) => css`
  position: relative;
  scroll-snap-align: center;
  padding: ${size[16]};
  border: 1px solid #0000002a;
  border-radius: ${theme.borderRadius.lg};

  width: 220px;
  flex-shrink: 0;
  ${breakpoint.up('lg')} {
    width: 265px;
    max-width: 340px;
    padding: ${size[24]} ${size[32]};
    padding-bottom: ${size[56]};

    &:nth-of-type(even) {
      top: ${size[48]};
    }
  }
`

export const cardTitle = css`
  font-size: ${pxToRem(18)};
  font-weight: 700;
  margin-bottom: ${size[16]};

  ${breakpoint.up('lg')} {
    font-size: ${pxToRem(26)};
  }
`

export const cardDesc = css`
  line-height: ${pxToRem(26)};
  margin-bottom: ${size[16]};

  font-size: ${pxToRem(15)};
  ${breakpoint.up('lg')} {
    font-size: ${pxToRem(16)};
  }
`

export const icon = (theme: Theme) => css`
  width: fit-content;
  padding: ${size[4]};
  margin-bottom: ${size[24]};
  background-color: #d4f0ee;
  border-radius: ${theme.borderRadius.md};
`

export const arrowIcon = css`
  fill: none;
`
